import RegionService from "@/services/region";

export default {
  search({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      RegionService.search({
        params,
        headers: {
          Authorization: localStorage.token,
        },
      })
        .then((response) => {
          commit("SET_DATA_SEARCH", response.data.data);
          resolve(response.data.data);
        })
        .catch((e) => reject(e));
    });
  },
  getProvinsi({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      RegionService.getProvinsi({
        params,
        headers: {
          Authorization: localStorage.token,
        },
      })
        .then((response) => {
          commit("SET_DATA", response.data.data);
          resolve(response.data.data);
        })
        .catch((e) => reject(e));
    });
  },
  getKota({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      RegionService.getKota({
        params,
        headers: {
          Authorization: localStorage.token,
        },
      })
        .then((response) => {
          commit("SET_DATA_KOTA", response.data.data);
          resolve(response.data.data);
        })
        .catch((e) => reject(e));
    });
  },
  getKecamatan({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      RegionService.getKecamatan({
        params,
        headers: {
          Authorization: localStorage.token,
        },
      })
        .then((response) => {
          commit("SET_DATA_KECAMATAN", response.data.data);
          resolve(response.data.data);
        })
        .catch((e) => reject(e));
    });
  },
};
